import { property } from '../../../concepts/objects';
import { Rect } from '../../../platform/geom/Rect';
import { TextAlignment, TextSettings } from '../entities/TextConventions';
import { UIField } from '../entities/UIField';
import { TextFieldType } from '../workspace/adapters/TextFieldType';
import { AdaptableField } from './AdaptableField';

export type GetRelativeLayout = () => [Rect, number];

export interface TextFieldProps extends TextSettings {
    readonly maxLength: number | null;
    readonly value: string;
}

export abstract class TextField extends AdaptableField implements TextFieldProps, UIField {


    public abstract get fontColor(): string;
    public abstract get fontFamily(): string;
    public abstract get fontSize(): number;
    public abstract get fontStyle(): string;
    public abstract get fontWeight(): number;
    public abstract get lineHeight(): number;
    public abstract get maxFontSize(): number | null;
    public abstract get maxLength(): number | null;
    public abstract get textAlignH(): TextAlignment;
    public abstract get textAlignV(): TextAlignment;
    public abstract get textMargin(): number | number[];

    public get type(): string {
        return 'text';
    }

    public get type2() {
        return TextFieldType;
    }

    public get ui() {
        return this.type2.ui;
    }

    @property({ type: 'string' })
    public value!: string;

    protected formatString() {
        return this.value;
    }

    public toTextSettings(): TextSettings {
        return {
            fontColor: this.fontColor,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontWeight: this.fontWeight,
            lineHeight: this.lineHeight,
            maxFontSize: this.maxFontSize,
            textAlignH: this.textAlignH,
            textAlignV: this.textAlignV,
            textMargin: this.textMargin,
        };
    };

    // TEMP:
    public get settings(): TextSettings {
        return this.toTextSettings();
    }
}
